import React from "react";
import TopNavBar from "./component/TopNavBar";
import DashboardHeader from "./component/DashboardHeader";
import StatsContainer from "./component/StatsContainer";
import { DashboardProvider } from "./contexts/DashboardContext";
import ChartsContainer from "./component/ChartsContainer";
import EmployeeDirectory from "./component/EmployeeDirectory";

export default function EmployeeMain() {
  return (
    // Wrap the entire component tree inside the Provider so data is available everywhere
    <DashboardProvider>
      <div className="flex flex-col w-full min-h-screen bg-slate-50 pb-10">
        <TopNavBar />

        <div className="p-4 sm:p-6 w-full max-w-screen-2xl mx-auto flex flex-col gap-6">
          <DashboardHeader />

          {/* This container will automatically loop and render all your cards */}
          <StatsContainer />

          <ChartsContainer />
          <EmployeeDirectory />
        </div>
      </div>
    </DashboardProvider>
  );
}
